module.exports = __webpack_public_path__ + "static/A2Bas_N010287.03d3baa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/A2Bas_N010287.jpg
// module id = 851
// module chunks = 168707334958949